<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 客渠管理
                </el-breadcrumb-item>
				<el-breadcrumb-item> 企业资料 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.provinceId" placeholder="请选择省" filterable @change="queryProvinceChange" style="width:180px">
					<el-option key="" label="请选择省" value=""></el-option>
					<el-option v-for="item in provinceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.cityId" placeholder="请选择城市" filterable @change="queryCityChange" style="width:180px">
					<el-option key="" label="请选择城市" value=""></el-option>
					<el-option v-for="item in queryCityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.areaId" placeholder="请选择区域" style="width:180px"  @change="queryAreaChange">
					<el-option key="" label="请选择区域" value=""></el-option>
					<el-option v-for="item in queryAreaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.locationId" placeholder="请选择工业区" filterable style="width:180px">
					<el-option key="" label="请选择工业区" value=""></el-option>
					<el-option v-for="item in industrialAreaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.name" placeholder="公司名称" class="handle-input mr10" style="width:220px"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-location" @click="showMap" v-if="controll['show-map']">分布图</el-button>
				&nbsp;
				<br/><br/>
				<el-select v-model="query.resourcesType" placeholder="请选择公司类型" style="width:150px">
					<el-option key="" label="请选择公司类型" value=""></el-option>
					<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态" style="width:150px">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="建档" value = "0"></el-option>
					<el-option key="1" label="数据分析中" value = "1"></el-option>
					<el-option key="2" label="数据分析完成" value = "2"></el-option>
					<el-option key="3" label="已发信息" value = "3"></el-option>
					<el-option key="4" label="已成好友" value = "4"></el-option>
					<el-option key="5" label="已沟通" value = "5"></el-option>
					<el-option key="6" label="已合作" value = "6"></el-option>
					<el-option key="7" label="无效" value = "7"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.keyType" placeholder="请选择关键字类型" @change = "getResourceKey" style="width:150px">
					<el-option key="" label="请选择关键字类型" value=""></el-option>
					<el-option key="0" label="设备" value="0"></el-option>
					<el-option key="1" label="品牌" value="1"></el-option>
					<el-option key="2" label="元器件" value="2"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.keyId" placeholder="请选择关键字" filterable style="width:150px">
					<el-option key="" label="请选择关键字" value=""></el-option>
					<el-option v-for="item in resourcesKeyKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.mailStatus" placeholder="请选择邮件沟通状态" filterable style="width:150px">
					<el-option key="" label="请选择邮件沟通状态" value=""></el-option>
					<el-option v-for="item in mailStatusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.level" placeholder="请选择级别" style="width:120px">
					<el-option key="" label="请选择级别" value=""></el-option>
					<el-option v-for="item in levelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				&nbsp;&nbsp;
				<el-checkbox v-model="query.asterisk" placeholder="星标记录">星标记录</el-checkbox>							
				<el-checkbox v-model="query.showCareKey" placeholder="显示关键字记录" style="padding:10px;">关键字记录</el-checkbox><br/>
				<!-- &nbsp;&nbsp;&nbsp;&nbsp;<el-dropdown class="user-name" trigger="click">
					<span class="el-dropdown-link">
						更多过滤
						<i class="el-icon-caret-bottom"></i>
					</span>
					<el-dropdown-menu slot="dropdown" style="padding:10px;">
						<el-checkbox v-model="query.showCareKey" placeholder="显示关键字记录" style="padding:10px;">关键字记录</el-checkbox><br/>	
						<el-checkbox v-model="query.showProductPageIsEmpty" placeholder="显示无产品页记录" style="padding:10px;">无产品页记录</el-checkbox><br/>	
					</el-dropdown-menu>
				</el-dropdown>-->
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
				@cell-dblclick="handleShow"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="公司名称"></el-table-column>
				<el-table-column prop="level" label="级别" width = "65px">
					<template slot-scope="scope">
						{{scope.row.level==0?"普通":"重点"}}
					</template>
				</el-table-column>
                <el-table-column prop="areaRemark" label="所在城市" :formatter="cityIdFormat" width = "160px"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat" width = "115px"></el-table-column>
				<el-table-column prop="resourcesType" label="资源类型" :formatter="customerTypeFormat" width = "110px"></el-table-column>
				<el-table-column prop="score" label="评分" width = "70px"></el-table-column>
				<el-table-column prop="matchEquipment" label="命中设备/元器件"></el-table-column>
				<el-table-column prop="mailStatus" label="邮件沟通"  width = "120px" :formatter="mailStatusFormat"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="showCollectInfo(scope.$index, scope.row)"
							v-if="controll['show-collect-info']"
                        >补充</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && (!scope.row.trackerId || scope.row.trackerId == scope.row.createBy)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-edit"
                    class="handle-del mr10"
                    @click="handleUpdateStatus"
					v-if="controll['update-status']"
                >更新状态</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-s-custom"
                    class="handle-del mr10"
                    @click="handleUpdateType"
					v-if="controll['update-type']"
                >更新资源类型</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-cpu"
                    class="handle-del mr10"
                    @click="handleScore"
					v-if="controll['score']"
                >重新评分</el-button>
				<el-button
                    type="warning"
                    icon="el-icon-remove-outline"
                    class="handle-del mr10"
                    @click="release"
					v-if="controll['release']"
                >释放企业</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-friendadd"
                    class="handle-del mr10"
                    @click="handleAssign"
					v-if="controll['assign']"
                >重新分配</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
					:page-sizes="[10, 20, 50]"
                    @current-change="handlePageChange"
					@size-change="handleSizeChange"
                ></el-pagination>
            </div>
        </div>

		<el-dialog v-dialogDrag :close-on-click-modal=false title="批量更新状态" :visible.sync="updateStatusVisible" width="40%">
            <el-form ref="statusForm" :model="statusForm" label-width="120px"  :rules="statusRules">
				<el-form-item label="资源状态" prop="status">
					<el-select v-model="statusForm.status" placeholder="请选择状态">
						<el-option key="" label="请选择状态" value=""></el-option>
						<el-option key="0" label="建档" value = "0"></el-option>
						<el-option key="3" label="已发信息" value = "3"></el-option>
						<el-option key="4" label="已成好友" value = "4"></el-option>
						<el-option key="5" label="已沟通" value = "5"></el-option>
						<el-option key="6" label="已合作" value = "6"></el-option>
						<el-option key="7" label="无效" value = "7"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="updateStatusVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateStatus" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="批量更新资源类型" :visible.sync="updateTypeVisible" width="40%">
            <el-form ref="typeForm" :model="typeForm" label-width="120px"  :rules="typeRules">
				<el-form-item label="资源类型" prop="resourcesType">
					<el-select v-model="typeForm.resourcesType" placeholder="请选择状态">
						<el-option key="" label="请选择公司类型" value=""></el-option>
						<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="updateTypeVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateType" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
		
		<v-PotentialResourcesEdit ref="potentialResourcesEdit"></v-PotentialResourcesEdit>
		<v-PotentialResourcesView ref="potentialResourcesView"></v-PotentialResourcesView>
		
		<el-dialog ref="mapDialog" v-dialogDrag title="客户分布图" :visible.sync="mapVisible" fullscreen>
			<div style="text-align:right;position:absolute;top:calc(100% - 27px)">
				<img src="../../../assets/img/point-red.png" width="16px">&nbsp;<span>设备生产商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-red-white.png" width="16px">&nbsp;<span>设备经销商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-blue.png" width="16px">&nbsp;<span>元器件生产商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-blue-white.png" width="16px">&nbsp;<span>元器件经销商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-s.png" width="16px">&nbsp;<span>未知生产商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-s-white.png" width="16px">&nbsp;<span>未知经销商</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-green.png" width="16px">&nbsp;<span>合作中客户</span>&nbsp;&nbsp;
				<img src="../../../assets/img/point-gold.png" width="16px">&nbsp;<span>标记客户</span>&nbsp;&nbsp;
			</div>
			<el-row>
				<el-col :span="leftColSize">
					<div style="width:calc(100% - 15px);float:left">
						<baidu-map :zoom="zoom" @ready="handler" class="bm-view"> </baidu-map>
					</div>
					<div class="spiltBar" @click="spiltBarClick">
						<img src="../../../assets/img/right.png" width="8px" v-if="this.conditionVisible">
						<img src="../../../assets/img/left.png" width="8px" v-if="!this.conditionVisible">
					</div>
				</el-col>
				<el-col :span="rightColSize">
					<div style="margin-left:10px;margin-right:10px;" v-if="conditionVisible">
						<el-tabs v-model="conditionActiveName" type="card">
							<el-tab-pane label="条件筛选" name="conditionTab">
								<el-row>
									<el-col :span="8">
										<el-select v-model="query.provinceId" placeholder="请选择省" filterable @change="queryProvinceChange" style="width:95%">
											<el-option key="" label="请选择省" value=""></el-option>
											<el-option v-for="item in provinceKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.cityId" placeholder="请选择城市" filterable @change="queryCityChange" style="width:95%">
											<el-option key="" label="请选择城市" value=""></el-option>
											<el-option v-for="item in queryCityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.areaId" placeholder="请选择区域" style="width:100%"  @change="queryAreaChange">
											<el-option key="" label="请选择区域" value=""></el-option>
											<el-option v-for="item in queryAreaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="8">
										<el-select v-model="query.locationId" placeholder="请选择工业区" filterable style="width:95%">
											<el-option key="" label="请选择工业区" value=""></el-option>
											<el-option v-for="item in industrialAreaKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.resourcesType" placeholder="请选择公司类型" style="width:95%">
											<el-option key="" label="请选择公司类型" value=""></el-option>
											<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.status" placeholder="请选择状态" style="width:95%">
											<el-option key="" label="请选择状态" value=""></el-option>
											<el-option key="0" label="建档" value = "0"></el-option>
											<el-option key="3" label="已发信息" value = "3"></el-option>
											<el-option key="4" label="已成好友" value = "4"></el-option>
											<el-option key="5" label="已沟通" value = "5"></el-option>
											<el-option key="6" label="已合作" value = "6"></el-option>
											<el-option key="7" label="无效" value = "7"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-input v-model="query.name" placeholder="公司名称" style="width:100%"></el-input>
									</el-col>
									<el-col :span="4">
										&nbsp;&nbsp;<el-checkbox v-model="query.asterisk" placeholder="星标" style="margin-top:7px;">星标</el-checkbox>
									</el-col>
									<el-col :span="8" style="text-align:right">
										<el-button type="primary" icon="el-icon-search" @click="loadMapByCondition" style="width:90%">筛选</el-button>
									</el-col>
								</el-row>
							</el-tab-pane>
							<el-tab-pane label="定位筛选" name="locationTab">
								<el-row>
									<el-col :span="16">
										<el-input v-model="query.locationAddress" placeholder="定位地址" style="width:95%"></el-input>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.range" placeholder="请选择范围" style="width:95%">
											<el-option key="" label="请选择范围" value=""></el-option>
											<el-option key="1000" label="1公里" value = "1000"></el-option>
											<el-option key="3000" label="3公里" value = "3000"></el-option>
											<el-option key="5000" label="5公里" value = "5000"></el-option>
											<el-option key="10000" label="10公里" value = "10000"></el-option>
											<el-option key="20000" label="20公里" value = "20000"></el-option>
											<el-option key="30000" label="30公里" value = "30000"></el-option>
											<el-option key="50000" label="50公里" value = "50000"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="8">
										<el-select v-model="query.resourcesType" placeholder="请选择公司类型" style="width:95%">
											<el-option key="" label="请选择公司类型" value=""></el-option>
											<el-option v-for="item in customerTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-select v-model="query.status" placeholder="请选择状态" style="width:95%">
											<el-option key="" label="请选择状态" value=""></el-option>
											<el-option key="0" label="建档" value = "0"></el-option>
											<el-option key="3" label="已发信息" value = "3"></el-option>
											<el-option key="4" label="已成好友" value = "4"></el-option>
											<el-option key="5" label="已沟通" value = "5"></el-option>
											<el-option key="6" label="已合作" value = "6"></el-option>
											<el-option key="7" label="无效" value = "7"></el-option>
										</el-select>&nbsp;&nbsp;
									</el-col>
									<el-col :span="8">
										<el-checkbox v-model="query.asterisk" placeholder="星标记录" style="margin-top:7px;">星标记录</el-checkbox>&nbsp;&nbsp;
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="16">
										<el-input v-model="query.name" placeholder="公司名称" style="width:100%"></el-input>
									</el-col>
									<el-col :span="8" style="text-align:right">
										<el-button type="primary" icon="el-icon-search" @click="loadMapByLocation()" style="width:90%">筛选</el-button>
									</el-col>
								</el-row>
							</el-tab-pane>
						</el-tabs>
						<br/>
						<el-tabs v-model="analysisActiveName" type="card">
							<el-tab-pane label="分析结果" name="analysisTab">
								<el-form ref="mapData" :model="mapData" label-width="70px">
									<el-form-item label="名称：">
										{{mapData.name}}
									</el-form-item>
									<el-row>
										<el-col :span="10">
											<el-form-item label="类型：">
												{{customerTypeFormat(null, null, mapData.resourcesType)}}
											</el-form-item>
										</el-col>
										<el-col :span="14">
											<el-form-item label="定位：">
												{{mapData.location?mapData.location:"-"}}
											</el-form-item>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="10">
											<el-form-item label="评分：">
												{{mapData.score?mapData.score:"-"}}
											</el-form-item>
										</el-col>
										<el-col :span="14">
											<el-form-item label="状态：">
												{{statusFormat(null, null, mapData.status)}}
											</el-form-item>
										</el-col>
									</el-row>
									<el-form-item label="评分项：">
										<p v-for="(item,i) in strToList(mapData.scoreItem)" :key="i">
											{{item}}
										</p>
									</el-form-item>
									<el-form-item label="产品：">
										<span :title="mapData.mainBusiness">{{strEllipsis(mapData.matchEquipment?mapData.matchEquipment:mapData.mainBusiness)}}</span>
									</el-form-item>
								</el-form>
							</el-tab-pane>
						</el-tabs>
					</div>
				</el-col>
			</el-row>
		</el-dialog>
		
		<v-PotentialResourcesCollectInfoAdd ref="potentialResourcesCollectInfoAdd"></v-PotentialResourcesCollectInfoAdd>
		
		<div class = "popver" ref = "popver" v-show="mapVisible && popverVisible" :style="{ 'z-index': popverZindex }">
			<div @click="popverSetUnder">置于底层</div>
			<div class="updateTo" @mouseover="subItemVisible=true" @mouseout="subItemVisible=false">
				<span>更新为...</span>
				<ul class="subItem" v-show="subItemVisible">
					<li @click="popverChangeType(0)">元器件生产商</li>
					<li @click="popverChangeType(1)">元器件经销商</li>
					<li @click="popverChangeType(2)">设备生产商</li>
					<li @click="popverChangeType(3)">设备经销商</li>
				</ul>
			</div>
			<div @click="popverSign">{{signName}}</div>
			<div @click="popverDel" v-if="!popverResources.trackerId || popverResources.trackerId == popverResources.createBy">删除</div>
		</div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="分配给" :visible.sync="assignVisible" width="30%">
            <el-form ref="trackerForm" :model="trackerForm" label-width="120px"  :rules="trackerRules">
				<el-form-item label="分配给" prop="trackerInfo">
					<el-cascader placeholder="请选择数据管理员"
						:options="options" :show-all-levels="false"
						v-model="trackerForm.trackerInfo" filterable clearable>
					</el-cascader>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="assignVisible = false">取 消</el-button>
                <el-button type="primary" @click="assign" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
		
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPotentialResourcesValidData, savePotentialResources, deletePotentialResources, 
getPotentialResources, getEnumValueKV, savePotentialResourcesBatch, getAreaKv, getSohuIP, 
getBaiduLocalCity, getPotentialResourcesSimple, updatePotentialResourcesStatus, getPotentialResourcesRuleKV, 
getApplyCompanyScoreLine, getPotentialResourcesPlatformKV, updatePotentialResourcesCollectInfo, 
scorePotentialResources,updatePotentialResourcesType, getPotentialResourcesKeyByType, getIndustrialAreaByCity, 
getIndustrialAreaByArea, updatePotentialResourcesMark, getOwnCompany, updateLatLng,
 assignPotentialResourcesCompany, releasePotentialResourcesCompany, getDepartmentUserTree } from '../../../api/index';
import vPotentialResourcesView from '../../common/PotentialResourcesView.vue';
import vPotentialResourcesEdit from '../../common/PotentialResourcesEdit.vue';
import vPotentialResourcesCollectInfoAdd from '../../common/PotentialResourcesCollectInfoAdd.vue';
import bus from '../../common/bus';
import Vue from 'vue';

import BaiduMap from 'vue-baidu-map-v3';
export default {
    name: 'company-info',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            idx: -1,
            id: -1,
			sourceEnumCode:1014,
			cityKV:{},
			sourceKV:{},
			statusRules:{
				status: [{ required: true, message: '请选择更新状态', trigger: 'blur' }],
			},
			typeRules:{
				resourcesType: [{ required: true, message: '请选择资源类型', trigger: 'blur' }],
			},
			trackerRules:{
				trackerInfo: [{ required: true, message: '请选择分配对象', trigger: 'blur' }],
			},
			show:[],
			activeName:"baseTab",
			customerTypeKV:[{"key":0,"value":"元器件生产商"},{"key":1,"value":"元器件经销商"},{"key":2,"value":"设备生产商"},{"key":3,"value":"设备经销商"},{"key":4,"value":"未知生产商"},{"key":5,"value":"未知经销商"}],
			provinceKV:[],
			cityKV:[],
			areaKV:[],
			queryCityKV:[],
			queryAreaKV:[],
			mapVisible:false,
			zoom:17,
			localCity:"北京市",
			baiduMap:{},
			baiduMapObj:{},
			mapData:{},
			conditionVisible:true,
			leftColSize:18,
			rightColSize:6,
			updateStatusVisible:false,
			statusForm:{},
			ruleKV:[],
			scoreLine:{},
			conditionActiveName:"conditionTab",
			analysisActiveName:"analysisTab",
			platformKV:[],
			resourceTypeImgMapping:{"0":"point-blue.png","1":"point-blue-white.png","2":"point-red.png","3":"point-red-white.png","4":"point-s.png","5":"point-s-white.png"},
			updateTypeVisible:false,
			typeForm:{},
			resourcesKeyKV:{},
			locationControl:{},
			defaultRange:"3000",
			industrialAreaKV:{},
			points:[],
			controll:{},
			mailStatusKV:[{"key":0,"value":"尚未发邮件"},{"key":2,"value":"邮件发送成功"},{"key":5,"value":"已阅读邮件"},{"key":6,"value":"已访问官网"},{"key":7,"value":"访问产品页"}],
			popverResources:{},
			popverVisible:false,
			popverMarker:{},
			popverZindex:0,
			mapZindex:0,
			subItemVisible:false,
			signName:"标记",
			levelKV:[{"key":0, "value":"普通"}, {"key":1, "value":"重点"}],
			assignVisible:false,
			options:[],
			trackerForm:{}
        };
    },
	components: {
        vPotentialResourcesView,
		vPotentialResourcesEdit,
		vPotentialResourcesCollectInfoAdd
    },
    created() {
		this.controll = getControll("company-info");
		this.getSourceKV();
		this.getTrackers();
        this.getData();
		this.getAreaKV(0, 0);
		this.getRuleKV();
		this.getScoreLine();
		this.getPlatformKV();
		bus.$on('potential-resources-change', msg => {
			if (this.idx == undefined) {
				this.getData();
			} else {
				this.$set(this.tableData, this.idx, msg);
			}
        });
    },
    methods: {
		getTrackers() {
			getDepartmentUserTree().then(res => {
				if (res.code == 0 ) {
					this.options = res.data;
					this.getDepartmentMapping(res.data, undefined, undefined);
				} else {
					this.$message.error("获取用户信息失败，" + res.message);
				}
			});
		},
		getDepartmentMapping(nodes, parent, parentName) {
			for(let i = 0; i < nodes.length; i++) {
				let node = nodes[i];
				let mapping = {};
				let departmentInfo = [];
				let name = "";
				if (parent) {
					departmentInfo = departmentInfo.concat(parent);
					name = parentName;
				}
				departmentInfo.push(node.value);
				name = (name?name + "/":"") + node.label;
				mapping["name"] = name;
				mapping["info"] = departmentInfo;
				this.departmentMapping[node.value+"-"+(node.sign?node.sign:"")] = mapping;
				if (node.children && node.children.length > 0) {
					this.getDepartmentMapping(node.children, departmentInfo, name);
				}
			}
		},
		userIdFormat(row, column, cellValue) {
			let mapping = this.departmentMapping[cellValue + "-1"];
			return mapping?mapping["name"]:cellValue;
		},
		handleScore() {
			let ids = this.getIds();
			if (ids == null) {
				return;
			}
			this.$confirm('确定要对选中记录进行重新评分吗？', '提示', {
                type: 'warning'
            })
			.then(() => {
					scorePotentialResources(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('发送指令成功');
						} else {
							this.$message.error(`发送指令失败！` + res.message);
						}
					});
				})
			.catch(() => {});
		},
		release() {
			let ids = this.getIds();
			if (ids == null) {
				this.$message.error(`请选择需要释放的企业资料！`);
				return;
			}
			this.$confirm('确定要释放选中的企业资料吗？', '提示', {
                type: 'warning'
            })
			.then(() => {
					releasePotentialResourcesCompany(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('释放成功');
							this.getData();
						} else {
							this.$message.error(`释放失败！` + res.message);
						}
					});
				})
			.catch(() => {});
		},
		handleAssign() {
			let ids = this.getIds();
			if (ids == null) {
				this.$message.error(`请选择需要重新分配的企业资料！`);
				return;
			}
			this.$set(this.trackerForm, "trackerInfo", []);
			this.assignVisible = true;
		},
		assign() {
			this.$refs.trackerForm.validate(valid => {
				if (valid) {
					let ids = this.getIds();
					this.$set(this.trackerForm, "ids", ids);
					this.$set(this.trackerForm, "trackId", this.trackerForm.trackerInfo[this.trackerForm.trackerInfo.length - 1]);
					assignPotentialResourcesCompany(this.trackerForm).then(res => {
						if (res.code == 0) {
							this.$message.success('分配成功');
							this.assignVisible = false;
						} else {
							this.$message.error(`分配失败！` + res.message);
						}
					});
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
		strEllipsis (value) {
			if (!value) return ''
			if (value.length > 90) {
				return value.slice(0, 90) + '...'
			}
			return value
		},
		getScoreLine() {
			getApplyCompanyScoreLine().then(res => {
				if (res.code == 0) {
					this.scoreLine["pass_line"] = res.data.passLine;
					this.scoreLine["excellent_line"] = res.data.excellentLine;
					if (res.data.mapApiId == 0 && res.data.mapApiAk) {
						Vue.use(BaiduMap, {
							ak: res.data.mapApiAk
						});
					}
				} else {
					this.$message.error(`获取企业营运数据失败！` + res.message);
				}
			});
		},
		getResourceKey(keyType) {
			this.$set(this.query, 'keyId', '');
			if (keyType == "") {
				this.resourcesKeyKV = {};
				return;
			}
			getPotentialResourcesKeyByType(keyType).then(res => {
				if (res.code == 0) {
					this.resourcesKeyKV = res.data;
				} else {
					this.$message.error(`获取关键字失败！` + res.message);
				}
			});
		},
		mailStatusFormat(row, column, cellValue) {
			let index = this.mailStatusKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.mailStatusKV[index].value;
		},
		getPlatformKV() {
				getPotentialResourcesPlatformKV().then(res => {
				if (res.code == 0) {
					this.platformKV = res.data;
				} else {
					this.$message.error(`获取辅助平台失败！` + res.message);
				}
			});
		},
		getRuleKV() {
			getPotentialResourcesRuleKV().then(res => {
				if (res.code == 0) {
					this.ruleKV = res.data;
				} else {
					this.$message.error(`获取规则数据失败！` + res.message);
				}
			});
		},
		closePopver() {
			this.popverVisible = false;
			this.popverResources = {};
		},
		showPopver(resources, left, top, marker) {
			this.popverVisible = true;
			let dom = this.$refs.popver;
			dom.style.left = (left - 210) + 'px';
			dom.style.top = top + 'px';
			if (this.popverZindex == 0) {
				this.popverZindex = this.getZIndex('content', 0) + 1;
			}
			this.signName = (resources["mark"]==1?"取消标记":"设置标记");
			this.popverResources = resources;
			this.popverMarker = marker;
		},
		getZIndex(className, type) {
			let z = 0;
			let elements = document.body.getElementsByClassName(className);
			if (className == 'content') {
				elements = elements[0].children[0].children;
			}
			Array.from(elements).forEach(element => {
				const style = window.getComputedStyle(element);
				const zIndex = style.getPropertyValue('z-index');
				if (zIndex && !isNaN(parseInt(zIndex))) {
					z = (type==0?Math.max(z, parseInt(zIndex)):(z==0?parseInt(zIndex):Math.min(z, parseInt(zIndex))));
				}
			});
			return z;
		},	
		popverDel(){
			this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResources([this.popverResources["id"]]).then(res => {
						if (res.code == 0) {
							this.$message.success(`删除成功！`);
							this.baiduMap.removeOverlay(this.popverMarker);
							this.popverVisible = false;
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
			
		},
		popverSetUnder() {
			if (this.mapZindex == 0) {
				this.mapZindex = this.getZIndex('BMap_Marker', 1) - 10000;
			}
			this.mapZindex = this.mapZindex - 1;
			this.popverMarker.setZIndex(this.mapZindex);
			this.baiduMap.panTo(this.popverMarker.getPosition());
			this.popverVisible = false;
		},
		popverChangeType(type) {
			let submitForm = {};
			let ids = [];
			ids.push(this.popverResources["id"]);
			submitForm["ids"] = ids;
			submitForm["resourcesType"] = type;
			this.$set(this.popverResources, "resourcesType", type);
			updatePotentialResourcesType(submitForm).then(res => {
				if (res.code == 0) {
					this.$message.success('更新成功');
					this.refreshMap();
				} else {
					this.$message.error(`更新失败！` + res.message);
				}
			});
		},
		popverSign() {
			let submitForm = {};
			let ids = [];
			ids.push(this.popverResources["id"]);
			let mark = (this.popverResources["mark"] == 1?0:1);
			submitForm["ids"] = ids;
			submitForm["mark"] = mark;
			this.$set(this.popverResources, "mark", mark);
			updatePotentialResourcesMark(submitForm).then(res => {
				if (res.code == 0) {
					this.$message.success('更新成功');
					this.signName = (this.popverResources["mark"]==1?"取消标记":"设置标记");
					this.refreshMap();
				} else {
					this.$message.error(`更新失败！` + res.message);
				}
			});
		},
		refreshMap() {
			this.popverVisible = false;
			this.baiduMap.removeOverlay(this.popverMarker);
			let points = [];
			points.push(this.popverResources)
			this.buildPoint(points);
			this.getData();
		},
		//分割栏点击操作
		spiltBarClick() {
			this.conditionVisible= !this.conditionVisible;
			this.leftColSize=this.conditionVisible?18:24;
			this.rightColSize=this.conditionVisible?6:0;
		},
		//评分项转列表
		strToList(val) {
			let list = [];
			if (val == undefined) {
				return list;
			}
			let array = val.split('，');
			for(var i = 0; i < array.length; i++) {
				list.push(array[i]);
			}
			return list;
		},
		geoCoder(pt){
			var action = this;
			var geoc = new this.baiduMapObj.Geocoder();
            geoc.getLocation(pt, function(rs){
				action.$set(action.query, 'locationAddress', rs.address);
				if (rs.addressComponents != undefined) {
					let key;
					if (rs.addressComponents.province != undefined) {
						key = action.valueToKey(action.provinceKV, rs.addressComponents.province);
						action.$set(action.query, "provinceId", key);
						action.queryCityKV = [];
						action.queryAreaKV = [];
						getAreaKv(key).then(res => {
							if (res.code == 0) {
								action.queryCityKV = res.data;
								if (rs.addressComponents.city != undefined) {
									key = action.valueToKey(action.queryCityKV, rs.addressComponents.city);
									action.$set(action.query, "cityId", key);
									getAreaKv(key).then(res => {
										if (res.code == 0) {
											action.queryAreaKV = res.data;
											if (rs.addressComponents.district != undefined) {
												key = action.valueToKey(action.queryAreaKV, rs.addressComponents.district);
												action.$set(action.query, "areaId", key);
											}
										} else {
											this.$message.error("获取区域信息失败！" + res.message);
										}
									});
								}
							} else {
								this.$message.error("获取区域信息失败！" + res.message);
							}
						});
					}
				}
				action.conditionActiveName = "locationTab";
				action.loadMapByLocation(pt);
            })
		},
		drawCircle(pt) {
			var action = this;
			var range = this.defaultRange;
			if (this.query.range != undefined) {
				range = this.query.range;
			}
			var circle = new this.baiduMapObj.Circle(pt, range, {
				strokeColor: 'red',
				strokeWeight: 1,
				strokeOpacity: 1,
				fillOpacity:0.1
			});
			this.baiduMap.addOverlay(circle);
			//标记定位未知
			var icon = new BMap.Icon("https://www.zelixin.cn/static/location.png", new BMap.Size(60, 35));
			var localHere = new this.baiduMapObj.Marker(pt, {"icon":icon});
			this.baiduMap.addOverlay(localHere);
		},
		//初始化地图
		handler({ BMap, map }) {
			this.baiduMap = map;
			this.baiduMapObj = BMap;
			let geoCoder = this.geoCoder;
			let drawCircle = this.drawCircle;
			let closePopver = this.closePopver;
			map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
			map.addControl(new BMap.NavigationControl()) // 添加平移缩放控件
			map.addControl(new BMap.ScaleControl()) // 添加比例尺控件
			map.addControl(new BMap.MapTypeControl())//添加地图类型
			// 将定位控件添加到地图上
			let locationControl = new BMap.GeolocationControl({
				anchor: BMAP_ANCHOR_TOP_RIGHT,
				offset: new BMap.Size(20, 50)
			});
			locationControl.addEventListener("locationSuccess", function(e){
				geoCoder(e.point);
			});
			locationControl.addEventListener("locationError",function(e){
				alert("定位失败");
			});
			map.addEventListener('click', function (e) {
				closePopver();
			});
			map.addControl(locationControl);			
        },
		//显示地图
		showMap() {
			if (this.query.provinceId == undefined || this.query.provinceId == '') {
				this.$message.error("请选择需要展示企业所在省份！");
				return;
			}
			if (this.query.cityId == undefined || this.query.cityId == '') {
				this.$message.error("请选择需要展示企业所在城市！");
				return;
			}
			this.mapVisible = true;
			setTimeout(this.loadMapByCondition, 500);
		},
		//通过条件定位加载地图数据
		loadMapByCondition() {
			this.loadMap();
		},
		//通过定位加载地图数据
		loadMapByLocation(pt) {
			if (this.query.locationAddress == undefined) {
				this.$message.error("定位地址信息不能为空");
				return;
			}
			if (this.query.range == undefined) {
				this.$set(this.query, 'range', this.defaultRange);
			}
			if (pt == null) {
				var action = this.loadMap;
				var myGeo = new this.baiduMapObj.Geocoder();
				myGeo.getPoint(this.query.locationAddress, function(point){
					if(point){
						action(point);
					}else{
						alert('您选择的地址没有解析到结果！');
					}
				}, '');
			} else {
				this.loadMap(pt);
			}
		},
		
		//加载地图元素
		loadMap(potion) {
			let zoom = 8;
			let address = "";
			this.baiduMap.clearOverlays();
			for (var i = 0; i < this.provinceKV.length; i++) {
				if (this.provinceKV[i].key === this.query.provinceId){
					address = address + this.provinceKV[i].value;
					break;
				}
			}
			if (this.query.cityId != undefined && this.query.cityId != '') {
				for (var i = 0; i < this.queryCityKV.length; i++) {
					if (this.queryCityKV[i].key === this.query.cityId){
						address = address + this.queryCityKV[i].value;
						break;
					}
				}
				zoom = 10;
			}
			if (this.query.areaId != undefined && this.query.areaId != '') {
				for (var i = 0; i < this.queryAreaKV.length; i++) {
					if (this.queryAreaKV[i].key === this.query.areaId){
						address = address + this.queryAreaKV[i].value;
						break;
					}
				}
				zoom = 12;
			}
			if (potion != undefined) {
				this.drawCircle(potion);
				this.$set(this.query, 'lng', potion.lng);
				this.$set(this.query, 'lat', potion.lat);
			} else {
				if (address != "") {
					this.localCity = address;
				}
				this.baiduMap.centerAndZoom(this.localCity, zoom);
				delete this.query['lng'];
				delete this.query['lat'];
			}	
			let condition = this.query;
			if (condition['asterisk'] == false) {
				delete condition['asterisk'];
			}
			delete condition['showCareKey'];
			getPotentialResourcesSimple(condition).then(res => {
				if (res.code == 0 ) {
					this.buildPoint(res.data);
				} else {
					this.$message.error("加载资源数据失败！" + res.message);
				}
			});
		},
		//构建地图标识
		buildPoint(resources) {
			let BMap = this.baiduMapObj;
			let map = this.baiduMap;
			let myGeo = new BMap.Geocoder();
			let buildMarker = this.buildMarker;
			let scoreLine = this.scoreLine;
			let points = this.points;
			for (var i = 0; i < resources.length; i++) {
				let resource = resources[i];
				let url = this.resourceTypeImgMapping[resource.resourcesType];
				if (resource.status == 6){
					url = "point-green.png";
				}
				if (resource.mark == 1){
					url = "point-gold.png";
				}
				if (resource.lng) {
					buildMarker(resource, url)
				} else {
					myGeo.getPoint(resource.address, function(point){
						if (point) {
							resource["lng"] = point.lng;
							resource["lat"] = point.lat;
							buildMarker(resource, url);
							updateLatLng(resource);
						}
					}, this.localCity);
				}
				
			}
		},		
		//构建客户图标，标注到地图上
		buildMarker(resource, url){
			let BMap = this.baiduMapObj;
			let map = this.baiduMap;
			let showPointSimpleInfo = this.showPointInfo;
			let showPointFullInfo = this.handleShow;
			let showPopver = this.showPopver;
			var host = "https://www.zelixin.cn/static/";
			var myIcon = new BMap.Icon(host + url, new BMap.Size(60, 35));
			var address = new BMap.Point(resource.lng, resource.lat);
			var marker = new BMap.Marker(address, {icon: myIcon});
			map.addOverlay(marker);
			let label = new BMap.Label(resource.name,{offset:new BMap.Size(30,0)});
			marker.setLabel(label);
			label.setStyle({                              // 设置label的样式
				borderRadius: '5px',
				borderColor: '#ccc',
				padding: '5px',
			});
			marker.addEventListener('click', function (event) {
				showPointSimpleInfo(resource.id);
			});
			marker.addEventListener('dblclick', function (event) {
				showPointFullInfo(resource);
			});
			marker.addEventListener('rightclick', function (event) {
				var inlineLeft = event.pixel.x;
				var inlineTop = event.pixel.y;
				if (!inlineLeft) {
					var rect = target.getBoundingClientRect();
					inlineLeft = rect.left; 
					inlineTop = rect.top;
				}
				showPopver(resource, inlineLeft, inlineTop, marker);
			});
		},
		//地图标识点击事件
		showPointInfo(id) {
			getPotentialResources(id).then(res => {
				if (res.code == 0) {
					this.mapData = res.data;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		provinceChange(value) {
			this.$set(this.form, 'cityId', '');
			this.areaKV = [];
			this.cityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 1);
		},
		cityChange(value) {
			this.areaKV = [];
			this.$set(this.form, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 2);
		},
		queryAreaChange(value) {
			if (value == "") return;
			this.getIndustrialAreaKV(1, value);
		},
		queryProvinceChange(value) {
			this.$set(this.query, 'cityId', '');
			this.queryAreaKV = [];
			this.queryCityKV = [];
			if (value == "") return;
			this.getAreaKV(value, 3);
		},
		queryCityChange(value) {
			this.queryAreaKV = [];
			this.$set(this.query, 'areaId', '');
			if (value == "") return;
			this.getAreaKV(value, 4);
			this.getIndustrialAreaKV(0, value);
		},
		//获取省市区
		getAreaKV(parentId, type) {
			getAreaKv(parentId).then(res => {
				if (res.code == 0 ) {
					if (type == 0) {
						this.provinceKV = res.data;
					} else if (type == 1){
						this.cityKV = res.data;
					} else if (type == 2){
						this.areaKV = res.data;
					} else if (type == 3){
						this.queryCityKV = res.data;
					} else if (type == 4){
						this.queryAreaKV = res.data;
					}
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		getIndustrialAreaKV(type, id) {
			this.industrialAreaKV = {};
			if (id == undefined) {
				return;
			}
			var getIndustrialArea = type == 0?getIndustrialAreaByCity:getIndustrialAreaByArea;
			getIndustrialArea(id).then(res => {
				if (res.code == 0 ) {
					this.industrialAreaKV = res.data;
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		//通过value查找key
		valueToKey(target, value) {
			for (var i = 0; i < target.length; i++) {
				if (target[i].value === value){
					return target[i].key;
				}
			}
			return value;
		},
		//客户类型格式化
		customerTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.customerTypeKV.length; i++) {
				if (this.customerTypeKV[i].key === cellValue){
					return this.customerTypeKV[i].value;
				}
			}
			return " - ";
		},
		cityIdFormat(row, column, cellValue) {
			for (var i = 0; i < this.cityKV.length; i++) {
				if (this.cityKV[i].key === cellValue){
					return this.cityKV[i].value;
				}
			}
			return cellValue;
		},
		typeFormat(row, column, cellValue) {
			for (var i = 0; i < this.companyTypeKV.length; i++) {
				if (this.companyTypeKV[i].key === cellValue){
					return this.companyTypeKV[i].value;
				}
			}
			return cellValue;
		},
		statusFormat(row, column, cellValue) {
			let statusKV = {"0":"建档", "1" :"数据分析中", "2":"数据分析完成","3" :"已发信息", "4":"已成好友", "5":"已沟通/拜访", "6":"已合作", "7":"无效"};
			if (typeof(cellValue) != undefined) {
				return statusKV[cellValue];
			}
			return cellValue;
		},
		getSourceKV() {
			getEnumValueKV(this.sourceEnumCode).then(res => {
				if (res.code == 0 ) {
					this.sourceKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
        // 获取数据
        getData() {
			if (this.query['showCareKey'] == false) {
				delete this.query['showCareKey'];
			}
			if (this.query['asterisk'] == false) {
				delete this.query['asterisk'];
			}
			delete this.query['lng'];
			delete this.query['lat'];
            fetchPotentialResourcesValidData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResources([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		handleUpdateStatus() {
			let ids = this.getIds();
			if (ids == null) {
				return;
			}
			this.$set(this.statusForm, 'ids', ids);
			this.$set(this.statusForm, 'status', '');
			this.updateStatusVisible = true;
		},
		updateStatus() {
			this.$refs.statusForm.validate(valid => {
				if (valid) {
					updatePotentialResourcesStatus(this.statusForm).then(res => {
						if (res.code == 0) {
							this.updateStatusVisible = false;
							this.$message.success('更新成功');
							this.getData();
						} else {
							this.$message.error(`更新失败！` + res.message);
						}
					});
				}
			});
		},
		updateType() {
			this.$refs.typeForm.validate(valid => {
				if (valid) {
					updatePotentialResourcesType(this.typeForm).then(res => {
						if (res.code == 0) {
							this.updateTypeVisible = false;
							this.$message.success('更新成功');
							this.getData();
						} else {
							this.$message.error(`更新失败！` + res.message);
						}
					});
				}
			});
		},
		handleUpdateType() {
			let ids = this.getIds();
			if (ids == null) {
				return;
			}
			this.$set(this.typeForm, 'ids', ids);
			this.$set(this.typeForm, 'resourcesType', '');
			this.updateTypeVisible = true;
		},
		getIds() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要操作的记录！`);
				return null;
			}
			let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		},
        // 编辑操作
        handleEdit(index, row) {
			if (this.controll['edit'] == undefined) {
				return;
			}
            this.idx = index;			
			getPotentialResources(row.id).then(res => {
				if (res.code == 0) {
					this.$nextTick(()=>{
						this.$refs.potentialResourcesEdit.setDatasource(res.data, "编辑", this.provinceKV, 
						this.ruleKV, undefined, this.sourceKV);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		// 显示操作
        handleShow(val) {
			if (this.controll['show'] == undefined) {
				return;
			}
			getPotentialResources(val.id).then(res => {
				if (res.code == 0) {
					this.$nextTick(()=>{
						this.$refs.potentialResourcesView.setDatasource(res.data, this.platformKV, false);
					});
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleSizeChange(val) {
			this.$set(this.query, 'pageSize', val);
            this.getData();
		},
		//显示采集信息
		showCollectInfo(index, row) {
			this.$nextTick(()=>{
				this.$refs.potentialResourcesCollectInfoAdd.setDatasource(row, this.platformKV);
			});
		},
    }
};
</script>

<style scoped>

.bm-view {
    width: 100%;
    height: 85vh;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:85vh;
	width:10px;
	float:right;
	text-align:center;
	line-height:85vh;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}

.el-form-item{
	margin-bottom: 8px;
}

.el-checkbox__label{
	padding-left:5px;
}

.popver {
	width:150px;
	border:1px solid #f0f0f0;
	background:#ffffff;
	padding:2px;
	position:absolute;
}

.popver div {
	border-bottom:1px solid #f0f0f0;
	cursor: pointer;
	padding:10px;
}

.popver div:hover{
	background:#f0f0f0;
}

.updateTo {
	height:20px;
}

.subItem {
	position:relative;
	padding:2px;
	border:1px solid #f0f0f0;
	background:#ffffff;
	top:-33px;
	left:143px;
}

.subItem li{
	border-bottom:1px solid #f0f0f0;
	cursor: pointer;
	padding:10px;
	list-style-type:none;
}

.subItem li:hover{
	background:#f0f0f0;
}
</style>
